module.exports = __webpack_public_path__ + "img/oxygen.c8147d1f.gif";